import { useAtom } from 'jotai';
import { cardScaleAtom, groupByAtom, viewLayoutAtom, customGroupsAtom, cardGroupAssignmentsAtom, cardOrderAtom, cardSubViewAtom, customGroupsManagerOpenAtom, groupOrderManagerOpenAtom } from '../cardView';
export const useCardView = () => {
    const [cardScale, setCardScale] = useAtom(cardScaleAtom);
    const [groupBy, setGroupBy] = useAtom(groupByAtom);
    const [viewLayout, setViewLayout] = useAtom(viewLayoutAtom);
    const [customGroups, setCustomGroups] = useAtom(customGroupsAtom);
    const [cardGroupAssignments, setCardGroupAssignments] = useAtom(cardGroupAssignmentsAtom);
    const [cardOrder, setCardOrder] = useAtom(cardOrderAtom);
    const [cardSubView, setCardSubView] = useAtom(cardSubViewAtom);
    const [customGroupsManagerOpen, setCustomGroupsManagerOpen] = useAtom(customGroupsManagerOpenAtom);
    const [groupOrderManagerOpen, setGroupOrderManagerOpen] = useAtom(groupOrderManagerOpenAtom);
    return {
        cardScale,
        setCardScale,
        groupBy,
        setGroupBy,
        viewLayout,
        setViewLayout,
        customGroups,
        setCustomGroups,
        cardGroupAssignments,
        setCardGroupAssignments,
        cardOrder,
        setCardOrder,
        cardSubView,
        setCardSubView,
        customGroupsManagerOpen,
        setCustomGroupsManagerOpen,
        groupOrderManagerOpen,
        setGroupOrderManagerOpen
    };
};
